import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ResultGetModel, ResultTestModel } from 'data/result/result.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: ResultTestModel;
  error: any;
};

const initState: SliceState = {
  error: false,
  data: {
    subjects: [],
    results: [],
  },
  status: 'idle',
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<ResultTestModel>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: {
    subjects: [],
    results: [],
  },
  status: 'error',
});

const resultSlice = createSlice({
  name: 'result',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default resultSlice;
